import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import { useState } from 'react'

const AddChargeAmountModalUI = ({ context, successMsg, errorList, setErrorList,
	addMode, submitted, onSubmit, onCancelClick,
	invoiceNumber, onInvoiceNumberChange, invoiceNumberError, setInvoiceNumberError,
	invoiceDateISO, onInvoiceDateISOChange, invoiceDateISOError, setInvoiceDateISOError,
	chargeAmountF, onChargeAmountFChange, chargeAmountFError, setChargeAmountFError,
	remarks, onRemarksChange, remarksError, setRemarksError,
	dueDateISO, onDueDateISOChange, dueDateISOError, setDueDateISOError,
	fileInput
}) => {
return (
<ModalFormUI
	context={context}
	titleLabel='Add Out-of-pocket Expenses'
	buttonLabel='Add'
	cancelLabel='Cancel'
	isOpen={addMode}
	onRequestClose={onCancelClick}
	successMsg={successMsg}
	errorList={errorList}
	setErrorList={setErrorList}
	onSubmit={onSubmit}
	busy={submitted}
>

	<InputTextSF
		type='text' name='invoiceNumber' label='Invoice Number'
		value={invoiceNumber} onChange={onInvoiceNumberChange}
		error={invoiceNumberError} setError={setInvoiceNumberError}
		required={true}
	/>

	<InputDateUI context={context} name='invoiceDateISO' label='Invoice Date'
		selectedDateISO={invoiceDateISO} onChange={onInvoiceDateISOChange}
		error={invoiceDateISOError} setError={setInvoiceDateISOError}
		required={true}
	/>

	<InputTextSF
		type='text' name='chargeAmountF' label='OOPE Amount'
		value={chargeAmountF} onChange={onChargeAmountFChange}
		error={chargeAmountFError} setError={setChargeAmountFError}
		required={true}
	/>

	<InputDateUI context={context} type='date' name='dueDateISO' label='Due Date'
		selectedDateISO={dueDateISO} onChange={onDueDateISOChange}
		error={dueDateISOError} setError={setDueDateISOError}
		required={true}
	/>

	<InputTextSF
		type='text' name='remarks' label='Remarks'
		value={remarks} onChange={onRemarksChange}
		error={remarksError} setError={setRemarksError}
	/>

	<div className={`w_input_fld required`}>
		<label style={{ display: 'block', marginBottom: '10px', marginTop: '10px' }}>
			Select File <span style={{color: 'red'}}>*</span>
		</label>
		<input
			type='file'
			ref={fileInput}
			required
			className='g_m_top_25'
			style={{ display: 'block', width: '100%' }}
		/>
	</div>

</ModalFormUI>
)
}

export default AddChargeAmountModalUI
